import ContentSingle from "../components/ContentSingle/ContentSingle"
import Footer from "../components/Footer/Footer"

function Search(){

    return(
        <>
        <ContentSingle title="Results for" form="search"/>
        </>
    )
}

export default Search